import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myCountElementsByAssetType',
  pure: false
})
export class CountElementsByAssetTypePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      if ( value.length !== 0 ) {
        return value.reduce(
          (n, item) => {
            if (args === 'photos') {
              return n + (item['type'] === 'photo');
            } else if (args === 'videos') {
              return n + (item['type'] === 'video');
            }
          }, 0);
      } else {
        return 0;
      }
    } else {
      return '-';
    }
  }
}
